import type { FC } from 'react';
import { Button, ComposedModal, ModalBody, ModalFooter, ModalHeader, Select, SelectItem, Stack, TextInput } from '@carbon/react';
import { ArrowRight, CheckmarkFilled } from '@carbon/icons-react';

import { useCodigoDeAcesso, type DadosDoCodigoDeAcesso } from '../../../logica/dinheiro/codigoDeAcesso';
import { ROTULOS } from '../../padroes/rotulos';
import styles from './ModalDoCodigo.module.scss';

// O MODAL DO CÓDIGO DE ACESSO (13/10/2026): o código num passo só, e no sucesso o caminho para criar o
// planejamento. Abre de qualquer tela (`abrirCodigoDeAcesso`), e mora uma vez só, na raiz do app.

export const ModalDoCodigo: FC<{ c: DadosDoCodigoDeAcesso }> = ({ c }) => (
  <ComposedModal open={c.aberto} size='sm' onClose={() => { c.fechar(); return false; }} selectorPrimaryFocus='#codigo-de-acesso'>
    <ModalHeader label='Maestra PRO' title={c.liberado ? c.liberado.titulo : 'Usar um código de acesso'} iconDescription={ROTULOS.fechar} />
    {c.liberado ? (
      <>
        <ModalBody>
          <Stack gap={5}>
            <CheckmarkFilled size={32} className={styles.feito} aria-hidden='true' />
            <p className={styles.texto}>{c.liberado.texto}</p>
          </Stack>
        </ModalBody>
        <ModalFooter>
          <Button kind='secondary' onClick={c.fechar}>Agora não</Button>
          <Button kind='primary' renderIcon={ArrowRight} onClick={c.liberado.criar} data-modal-primary-focus>Criar o planejamento</Button>
        </ModalFooter>
      </>
    ) : (
      <>
        <ModalBody hasForm>
          <form id='form-do-codigo' noValidate onSubmit={(e) => { e.preventDefault(); c.usar(); }}>
            <Stack gap={6}>
              <p className={styles.texto}>
                {c.nomeDoPerfil && !c.perfis
                  ? `O código libera o planejamento estratégico de ${c.nomeDoPerfil}, sem cobrança.`
                  : 'O código libera o planejamento estratégico de um perfil, sem cobrança.'}
              </p>
              {c.semPerfil && <p className={styles.texto}>Todos os seus perfis já estão liberados.</p>}
              {c.perfis && (
                <Select id='codigo-perfil' labelText='Perfil' value={c.escolhido ?? ''} onChange={(e) => c.escolher(e.target.value || null)}>
                  <SelectItem value='' text='Escolha o perfil' />
                  {c.perfis.map((p) => <SelectItem key={p.id} value={p.id} text={p.nome} />)}
                </Select>
              )}
              <TextInput id='codigo-de-acesso' labelText='Código de acesso' placeholder='XXXX-XXXX-XXXX' maxLength={30} value={c.codigo} autoComplete='off'
                invalid={!!c.erro} invalidText={c.erro ?? undefined} onChange={(e) => c.mudarCodigo(e.target.value)} />
            </Stack>
          </form>
        </ModalBody>
        <ModalFooter>
          <Button kind='secondary' onClick={c.fechar}>Cancelar</Button>
          <Button kind='primary' type='submit' form='form-do-codigo' disabled={c.resgatando || c.semPerfil}>
            {c.resgatando ? 'Conferindo o código…' : 'Usar o código'}
          </Button>
        </ModalFooter>
      </>
    )}
  </ComposedModal>
);

export const ModalDoCodigoLigado: FC = () => <ModalDoCodigo c={useCodigoDeAcesso()} />;
